import React, { useState } from 'react'
import Card from '../../controls/Card';
import Container from '../../base/Container';
import GetAllRegistered from './GetAllRegistered';
import GetTodaysRegistered from './GetTodaysRegistered';
import GetAllConfirmed from './GetAllConfirmed';
import GetTodaysConfirmed from './GetTodaysConfirmed';
import GetAllEmergency from './GetAllEmergency';
import GetTodaysEmergency from './GetTodaysEmergency';
import Select from '../../controls/Select';
import { MdHistory } from 'react-icons/md';

export default function OpdRegister() {
    const [selectedCenterData, setSelectedCenterData] = useState(1);
    return (
        <Container title={"Opd History"}>
            <div className='w-full'>
                <Card title={"Opd History"} isBorder={true}  isUser={true}>
                    <div className='flex flex-col '>
                        <div className='flex flex-col sm:flex-row sm:space-x-3'>
                            <div className='w-full pt-2'>
                                <label for="OPDHistory" class="block mb-2 text-sm font-medium text-gray-900 ">Select Search Type</label>
                                <Select class="drop-down"
                                    Icon={<MdHistory className='text-sky-600 text-lg' />}
                                    value={selectedCenterData}
                                    onChange={(e) => setSelectedCenterData(e.target.value)}
                                >
                                    <option value={1} selected>Registered</option>
                                    <option value={2}>Today's Registerd</option>
                                    <option value={3}>Confirmed</option>
                                    <option value={4}>Today's Confirmed</option>
                                    <option value={5}>Emergency</option>
                                    <option value={6}>Today's Emergency</option>
                                </Select>
                            </div>
                        </div>
                    </div>
                    {selectedCenterData == 1 && <GetAllRegistered />}
                    {selectedCenterData == 2 && <GetTodaysRegistered />}
                    {selectedCenterData == 3 && <GetAllConfirmed />}
                    {selectedCenterData == 4 && <GetTodaysConfirmed />}
                    {selectedCenterData == 5 && <GetAllEmergency />}
                    {selectedCenterData == 6 && <GetTodaysEmergency />}
                </Card>
            </div>
        </Container>
    )
}
